import React from 'react';
import { useDispatch } from 'react-redux';

import { useReplyOnboardingContext } from '../../utils/replyOnboardingContext';
import { useMessageContext } from '../../utils/messageContext';
import { Responsive } from '@cian/ui-kit';
import { BubblesContainer } from '../../containers/ChatMessageContainer/containers/BubblesContainer';
import { ChatMessageSwipeReply } from '../ChatMessageSwipeReply';
import { ReplyOnboardingTooltip } from '../ReplyOnboardingTooltip';
import { setActiveReplyMessage } from '../../actions/chat';

interface IChatMessageReplyLayoutProps {
  children: React.ReactElement;
}

export const ChatMessageReplyLayout: React.FC<IChatMessageReplyLayoutProps> = React.memo(
  function ChatMessageReplyLayout({ children }) {
    const { messageId, chatId } = useMessageContext();

    const { isReplyOnboardingTargetMessage } = useReplyOnboardingContext();
    const isReplyOnboardingTarget = isReplyOnboardingTargetMessage(messageId);

    const dispatch = useDispatch();
    const handleSwipe = React.useCallback(() => {
      dispatch(setActiveReplyMessage({ chatId, messageId }));
    }, [dispatch, chatId, messageId]);

    return (
      <>
        <Responsive desktop>
          <ReplyOnboardingTooltip isOnboardingTarget={isReplyOnboardingTarget}>{children}</ReplyOnboardingTooltip>
          <BubblesContainer />
        </Responsive>

        <Responsive phone tablet>
          <ChatMessageSwipeReply
            onSwipe={handleSwipe}
            isSwipeOnboardingTarget={isReplyOnboardingTarget}
            bubbles={<BubblesContainer />}
          >
            {children}
          </ChatMessageSwipeReply>
        </Responsive>
      </>
    );
  },
);
